import axios from 'axios';
import { URL_API } from '../../consts/urls';
import {
    getLocalStorage,
    rmLocalStorage,
    setLocalStorage,
    TOKEN_NAME,
    REFRESH_TOKEN,
} from '../../consts/localStorage';

/** Refresh Token Implementation */

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        refreshTokenAndReAttempFunction(error);
        return Promise.reject(error);
    }
);

const refreshTokenAndReAttempFunction = (error) => {
    const originalRequest = error.config;

    // if the refresh token is expired, go to login page
    if (error.response.status === 401 && originalRequest.url === `${URL_API}refresh_token`) {
        rmLocalStorage(REFRESH_TOKEN);
        rmLocalStorage(TOKEN_NAME);
        window.location.href = '/';

        return Promise.reject(error);
    }

    if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        const refreshToken = getLocalStorage(REFRESH_TOKEN);

        return axios
            .post(`${URL_API}refresh_token`, null, {
                headers: { Authorization: `JWT ${refreshToken}` },
            })
            .then((res) => {
                if (res.status === 200) {
                    const accessToken = res.data.access_token;
                    setLocalStorage(accessToken);
                    originalRequest.headers['Authorization'] = 'JWT ' + accessToken;
                    return axios(originalRequest);
                }
            });
    }
};

export const authCall = (url, data, headers, method) =>
    axios({
        method,
        url: URL_API + url,
        data,
        headers,
    });

export const apiCall = (url, data, token, method,headers) =>
    axios({
        method,
        url: URL_API + url,
        data,
        headers: {
            Authorization: `JWT ${token}`,
            'Content-Type': 'application/json',
            ...headers,
        },
    });
